// removed by extract-text-webpack-plugin
module.exports = {"component":"_2xSBB2mXkR9iiKIlcAg1D3","border":"_33LhQh6zIX_vuE9XubPFm8","jsdd":"_9W85BSmStyncavz7Aa8Bo","jsallshou":"_1hno7VY1KgwbvSSUwa7cLc","img":"_1vDC6z1UokpcXRMbB_E1h7","linka":"_2ePuEU-8GUW4Ab43TkGXJu","productlie":"_4j2CZwSsITC5X4oQWjQLT","productli":"_1iAThZLXlYVb_eTawLV_Y6","imga":"_3P_H1P977lcstV7k7bxhQy","imgb":"_101Rbu4wZlUx_xGILMvU3M"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopProducts/ExperienceShopProducts.scss
 ** module id = 1064
 ** module chunks = 0
 **/